const getRolesList = state => state?.rules?.rolesList
const getRuleEngine = state => state?.rules?.ruleEngine
const getCorpList = state => state?.rules?.corpList
const getRuleSetData = state => {
  return state?.rules?.ruleSet
}
const getRuleDetailsById = state => {
  return state?.rules?.ruleDetailsById
}
const getAlreadySetDegreeList = state => {
  return state?.rules?.alreadySetDegreeList
}
const getRulesDegreesMetrics = state => {
  return state?.rules?.rulesDegreesMetrics
}

const getSelectedDegreeAndDepart = state => {
  return state?.rules?.selectedDegreesAndDepartList
}
const getRuleStreamMap = state => {
  return state?.rules?.ruleDegreeStreamMap
}

const selectors = {
  getRolesList,
  getRuleEngine,
  getCorpList,
  getRuleSetData,
  getRuleDetailsById,
  getAlreadySetDegreeList,
  getRulesDegreesMetrics,
  getSelectedDegreeAndDepart,
  getRuleStreamMap,
}

export default selectors
